import { useRouter } from 'expo-router'

import { useRoutes } from '@/src/general/utils/routes'

export const useCommunityBackAction = ({
  referrerAction,
  redirect,
}: {
  referrerAction?: () => { onBackPress: () => void }
  redirect: string | undefined
}) => {
  // oxlint-disable-next-line react-compiler/react-compiler
  'use no memo' // Disable React Compiler optimization - tests call this hook directly without renderHook()
  const { canGoBack, back, navigate, replace } = useRouter()
  const { routes } = useRoutes()

  // hasReferrer is required when user is trying to navigating back to legacy page
  if (redirect) {
    return { onBackPress: () => navigate(redirect) }
  } else if (canGoBack()) {
    return { onBackPress: back }
  } else if (referrerAction) {
    return referrerAction()
  }
  return { onBackPress: () => replace(routes.communities()) }
}
